import { NetworkActionTypes, NetworkState } from './types';
import { Reducer } from 'redux';
import { ActionType } from 'typesafe-actions';
import * as networkActions from './actions';
export type NetworkSvsAction = ActionType<typeof networkActions>;

// Type-safe initialState!
const initialState: NetworkState = {
  isConnected: true,
  actionQueue: []
};

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<NetworkState, NetworkSvsAction> = (state = initialState, action): NetworkState => {
  switch (action.type) {
    case NetworkActionTypes.NETWORK_STATUS_CHANGED: {
      return { ...state, isConnected: action.payload.connected };
    }
    default: {
      return state;
    }
  }
};

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export { reducer as networkReducer, initialState as networkInitialState };
